import { Deserializable } from '../protocols/deserializable';
import { BlockingSubmission } from './blocking-submission';

export class SubmissionAvailability implements Deserializable {
  public canStart!: boolean;
  public reason!: string | null;
  public blockingSubmission!: BlockingSubmission | null;

  // The reason banner only explains a refusal that no other banner on the screen already covers
  public reasonWithoutBanner(hasOtherBanner: boolean): string | null {
    return this.canStart || hasOtherBanner ? null : this.reason;
  }

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.blockingSubmission) {
      this.blockingSubmission = Deserialize.instanceOf(BlockingSubmission, this.blockingSubmission);
    }
  }
}
